<template>
  <div>
      <el-button  type="success"
           icon="el-icon-download"  @click="onButtonTitleButton">{{buttonTitle}}</el-button>
  </div>
</template>

<script>
import {formatDate} from '@/filters'
import { export_json_to_excel } from "@/excel/Export2Excel";
export default {
   props: {
    buttonTitle:{
        type: String,
        default: ''
    },
    path:{
        type: String,
        default: ''
    },
    tableLabels: {
      type: Array,
      default: function(){},
    },
    labels: {
      type: Array,
      default: function(){},
    },
  },
  methods: {
    onButtonTitleButton(){
        this.exportExcel()
    },
    exportExcel() {
      require.ensure([], () => {
        const tHeader = this.tableLabels.map((v) => {
          return v.label;
        }); // Excel的表头
        const filterVal = this.tableLabels.map((v) => {
          return v.prop;
        }); // 数据对应的字段
        let list=''
         list = this.labels.map((v)=>{ 
            v.createdAt =  formatDate(v.createdAt)
             return v
        })
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "user Activity Logs");
      });
    },
    formatJson(filterVal, jsonData) {
      if(jsonData.length>0){
       return jsonData.map((v) => filterVal.map((j) => v[j]));
      } else {
        return []
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
</style>